import { useLocation } from 'react-router-dom';

import { AppRoutes } from '@/utils';

const useIsPartnerScorePages = () => {
  const location = useLocation();

  return [AppRoutes.PARTNERSCORE, AppRoutes.CESSCORE, AppRoutes.CSATSCORE, AppRoutes.NPSSCORE].includes(
    location.pathname as AppRoutes,
  );
};

export default useIsPartnerScorePages;
